import i18next from 'i18next';

i18next.addResources('es_CL', 'NavbarSettings', {
  logout: 'Salir'
});

i18next.addResources('es_CR', 'NavbarSettings', {
  logout: 'Salir'
});
